import React from 'react';
import { Modal, Space, Tag, Button, Spin, Table, Pagination, Typography } from 'antd';
import { ScissorOutlined } from '@ant-design/icons';
import {
    DATA_COLLECTIONS_PAGE_SIZE_OPTIONS,
    DATA_COLLECTIONS_SIZE_CHANGER_SELECT_PROPS,
} from './collectionUtils';

const { Text } = Typography;

const PreviewModal = ({ open, data, loading, page, pageSize, onPageChange, onClose }) => (
    <Modal
        title={data?.content_type === 'document' ? 'Document Chunks Preview' : 'Data Preview'}
        open={open}
        onCancel={onClose}
        footer={[<Button key="close" onClick={onClose}>Close</Button>]}
        width={1000}
        className="preview-modal"
    >
        {loading ? (
            <div className="preview-loading"><Spin size="large" /><p>Loading preview...</p></div>
        ) : data?.content_type === 'document' ? (
            <div className="document-preview">
                <div className="document-meta">
                    <Space size="middle" wrap>
                        <Tag color="blue">{data.file_type?.toUpperCase()}</Tag>
                        <Tag color="purple"><ScissorOutlined /> {data.chunking_method}</Tag>
                        <Text type="secondary">
                            Showing {data.offset !== undefined ? `${data.offset + 1}-${data.offset + data.preview_count}` : data.preview_count} of {data.total_chunks} chunks
                        </Text>
                    </Space>
                    {data.document_metadata && (
                        <div className="document-stats">
                            {data.document_metadata.word_count && <Text type="secondary">{data.document_metadata.word_count.toLocaleString()} words</Text>}
                            {data.document_metadata.page_count && <Text type="secondary">{data.document_metadata.page_count} pages</Text>}
                        </div>
                    )}
                </div>
                <div className="chunks-list">
                    {data.chunks?.map((chunk, i) => (
                        <div key={i} className="chunk-item">
                            <div className="chunk-header">
                                <Tag color="geekblue">Chunk {chunk.index + 1}</Tag>
                                <Text type="secondary">{chunk.full_length} chars</Text>
                            </div>
                            <div className="chunk-content">{chunk.content}</div>
                        </div>
                    ))}
                </div>
                {data.total_chunks > pageSize && (
                    <div className="document-preview-pagination">
                        <Pagination
                            current={page}
                            pageSize={pageSize}
                            total={data.total_chunks}
                            onChange={onPageChange}
                            onShowSizeChange={onPageChange}
                            showSizeChanger={DATA_COLLECTIONS_SIZE_CHANGER_SELECT_PROPS}
                            pageSizeOptions={DATA_COLLECTIONS_PAGE_SIZE_OPTIONS}
                            showTotal={(total, range) => (
                                <span className="collections-pagination-total">
                                    {range[0].toLocaleString()}–{range[1].toLocaleString()} of {total.toLocaleString()} chunks
                                </span>
                            )}
                            size="small"
                        />
                    </div>
                )}
            </div>
        ) : data ? (
            <Table
                dataSource={data.rows}
                columns={data.columns?.map(col => ({ title: col, dataIndex: col, key: col, ellipsis: true })) || []}
                pagination={{ pageSize: 5 }}
                size="small"
                scroll={{ x: 'max-content' }}
                rowKey={(_, index) => index}
            />
        ) : null}
    </Modal>
);

export default PreviewModal;
